import { useEffect, useState } from "react";
import { ShieldCheck, Landmark, Lock, BadgeCheck } from "lucide-react";
import { api } from "@/lib/api";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AUDIENCES = ["Family Offices", "Qualified Intermediaries", "Attorneys", "RIAs", "Wealth Managers"];
const SIGNALS = [
  { icon: ShieldCheck, label: "Patent Pending" },
  { icon: Lock, label: "Bank-grade security" },
  { icon: Landmark, label: "FDIC-insured escrow" },
  { icon: BadgeCheck, label: "SOC-ready controls" },
];

export const TrustedBy = () => {
  const [cfg, setCfg] = useState(null);
  useEffect(() => {
    api.get("/settings").then((r) => setCfg(r.data)).catch(() => setCfg({ social_proof_enabled: false }));
  }, []);

  if (!cfg || cfg.social_proof_enabled === false) return null;
  const logos = cfg.social_proof_logos || [];

  return (
    <section data-testid="trusted-by-strip" className="border-y border-white/10 bg-white/[0.02]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-10">
        <p className="text-center text-xs uppercase tracking-[0.25em] font-bold text-white/40">
          Trusted by 1031 professionals
        </p>

        {logos.length > 0 && (
          <div data-testid="trusted-logos" className="mt-7 flex flex-wrap items-center justify-center gap-x-12 gap-y-6">
            {logos.map((l) => (
              <img
                key={l.id}
                src={`${API}/social-proof/logos/${l.id}`}
                alt={l.name}
                title={l.name}
                className="h-9 w-auto max-w-[160px] object-contain opacity-70 hover:opacity-100 grayscale hover:grayscale-0 transition-all"
              />
            ))}
          </div>
        )}

        <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
          {AUDIENCES.map((a) => (
            <span key={a} className="text-sm font-semibold text-white/70 bg-white/5 border border-white/10 rounded-full px-4 py-1.5">
              {a}
            </span>
          ))}
        </div>

        <div className="mt-5 flex flex-wrap items-center justify-center gap-x-8 gap-y-3">
          {SIGNALS.map((s) => (
            <span key={s.label} className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-wider text-white/50">
              <s.icon size={15} className="text-ally-pink" /> {s.label}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};
